import { render, staticRenderFns } from "./TargetAndReward.vue?vue&type=template&id=c58a2464&scoped=true&"
import script from "./TargetAndReward.vue?vue&type=script&lang=js&"
export * from "./TargetAndReward.vue?vue&type=script&lang=js&"
import style0 from "./TargetAndReward.vue?vue&type=style&index=0&id=c58a2464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58a2464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c58a2464')) {
      api.createRecord('c58a2464', component.options)
    } else {
      api.reload('c58a2464', component.options)
    }
    module.hot.accept("./TargetAndReward.vue?vue&type=template&id=c58a2464&scoped=true&", function () {
      api.rerender('c58a2464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Barcode/components/TargetAndReward.vue"
export default component.exports